import { PatientLocation } from '../../redux-stores/patientContext';

export default function buildPatientLocation(patientLocation: PatientLocation | undefined) {
  const { pointOfCare, bed, room, facility } = patientLocation || {};

  const location = [pointOfCare, room, bed, facility].filter((x) => x).join(' ');
  return location;
}
